import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CentralClienteRetornoComponent } from './central-cliente-retorno.component';

const routes: Routes = [];

@NgModule({
  imports: [RouterModule.forChild([
    {path:'', component: CentralClienteRetornoComponent}
  ])],
  exports: [RouterModule]
})
export class CentralClienteRetornoRoutingModule { }
